// Live formatted metric-card values for the PDF export, published by the Key
// metrics tray (mirrors gridPdfSnapshot for the table). Keyed by metric label so
// build-report-data can look each card up. Null until the tray renders live data;
// the PDF builder falls back to the placeholder values then.

export interface CardPdfCell {
	value: string
	change: string
	direction?: 'up' | 'down'
	trend?: 'positive' | 'negative' | 'neutral'
}

export const cardsPdfSnapshot: { current: Record<string, CardPdfCell> | null } = {
	current: null
}
